import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import InfoIcon from "@mui/icons-material/Info";
import DownloadDoneIcon from "@mui/icons-material/DownloadDone";
import {
  IconButton,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ClassNameGenerator from "@mui/utils/ClassNameGenerator";
import moment from "moment";
// import ImageView from "./ImageView";

const ModalHeader = styled("div")({
  fontSize: "20px",
  fontWeight: "700",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  position: "sticky",
  top: 0,
  background: "#fff",
  zIndex: 9,
  paddingTop: "10px",
  borderBottomLe: "1px slid red",
});
const ModalBody = styled("div")({
  padding: "15px",
});
export default function ViewCompanyPremisson(props) {
  const {
    width,
    openModal,
    setOpenModal,
    ExpencesData,
    ModalType,
    geofanceShowPremison,
    AttendanceShowPremison,
  } = props;
  const [open, setOpen] = React.useState(false);
  const [imageUrl, setImageUrl] = React.useState([]);
  const handleOpen = (data) => {
    setImageUrl(data);
    setOpen(true);
  };
  const handleClose = () => setOpenModal(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: width ? width : "50%",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "10px",
    overflow: "hidden",
    height: "50vh",
    overflow: "auto",
  };

  console.log(AttendanceShowPremison, "ExpencesData");

  return (
    <div>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ModalHeader>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{ marginLeft: "15px" }}
            >
              {ModalType === "Attendance" ? "Attendance" : "Geofence"}
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </ModalHeader>
          <ModalBody>
            <TableContainer>
              <Table size="small" id="FlowUpTable">
                <TableHead>
                  <TableRow
                    style={{
                      backgroundColor: "rgb(32 80 130)",
                      color: "#fff",
                    }}
                    key={1}
                  >
                    <TableCell style={{ color: "#fff" }} align="center">
                      S.No
                    </TableCell>

                    <TableCell style={{ color: "#fff" }} align="center">
                      {ModalType === "Attendance" ? "User (Emp Code)" : "User"}
                    </TableCell>
                    <TableCell style={{ color: "#fff" }} align="center">
                      {ModalType === "Attendance"
                        ? "Attendence Only by Our App"
                        : "Latitude Longitude"}
                    </TableCell>
                  </TableRow>
                </TableHead>
                {ModalType === "Attendance" ? (
                  <>
                    {AttendanceShowPremison &&
                      AttendanceShowPremison &&
                      AttendanceShowPremison.map((val, ind) => {
                        console.log(val, "dkjfgeuyfueyrf");
                        return (
                          <>
                            <TableBody>
                              <TableCell align="center">{ind + 1}</TableCell>

                              <TableCell
                                align="center"
                                style={{
                                  minWidth: "160px",
                                }}
                              >
                                {`${
                                  val.userName && val.userName !== null
                                    ? val.userName
                                    : "NA"
                                } ${
                                  val.empCode == null ? "" : `(${val.empCode})`
                                }`}
                              </TableCell>
                              <TableCell align="center">
                                {val &&
                                val.isAttendenceOnlybyOurApp &&
                                val.isAttendenceOnlybyOurApp !== null
                                  ? val.isAttendenceOnlybyOurApp === true
                                    ? "true"
                                    : "false"
                                  : "NA"}
                              </TableCell>
                            </TableBody>
                          </>
                        );
                      })}
                  </>
                ) : (
                  <>
                    {geofanceShowPremison &&
                      geofanceShowPremison &&
                      geofanceShowPremison.map((val, ind) => {
                        console.log(val, "dkjfgeuyfueyrf");
                        return (
                          <>
                            <TableBody>
                              <TableCell align="center">{ind + 1}</TableCell>

                              <TableCell
                                align="center"
                                style={{
                                  minWidth: "160px",
                                }}
                              >
                                {`${
                                  val.userName && val.userName !== null
                                    ? val.userName
                                    : "NA"
                                } ${
                                  val.empCode == null ? "" : `(${val.empCode})`
                                }`}
                              </TableCell>
                              <TableCell align="center">
                                {`${
                                  val && val.latitude !== null
                                    ? val.latitude
                                    : "NA"
                                } ${
                                  val && val.longitude !== null
                                    ? val.longitude
                                    : ""
                                }`}
                              </TableCell>
                            </TableBody>
                          </>
                        );
                      })}
                  </>
                )}
              </Table>
            </TableContainer>
          </ModalBody>
        </Box>
      </Modal>
    </div>
  );
}
